module.exports = __webpack_public_path__ + "img/16.bd79dca2.png";